export default class ApartmentNameCompletion {
  private apartmentNameInput: HTMLInputElement;

  private postalCodeInput: HTMLInputElement;

  private box: HTMLDivElement;

  private endpoint: string;

  private debounceTimeout?: number;

  constructor() {
    this.apartmentNameInput = document.getElementsByClassName('js-autocomplete-input')[0] as HTMLInputElement;
    this.postalCodeInput = document.getElementsByClassName('js-format-postal-code')[0] as HTMLInputElement;
    this.box = document.getElementsByClassName('js-suggestions')[0] as HTMLInputElement;
    this.endpoint = '/apartment_catalog_items/suggest';
  }

  /** 初期化：イベント登録 */
  enableCompletion(): void {
    this.apartmentNameInput.addEventListener('input', () => this.onInput());
    this.apartmentNameInput.addEventListener('blur', () => {
      setTimeout(() => {
        this.box.hidden = true;
      }, 800);
    });
    this.box.addEventListener('click', e => this.onClick(e));
  }

  /** デバウンス付き入力ハンドラ */
  private onInput(): void {
    if (!this.apartmentNameInput.classList.contains('js-test-suggestion')) {
      return;
    }
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = window.setTimeout(async () => {
      const postalCode = this.postalCodeInput.value.trim();
      const q = this.apartmentNameInput.value.trim();
      if (!q || !postalCode) {
        this.hide();
        return;
      }
      const items: string[] = await this.fetchSuggestions(q, postalCode);
      if (items.length) {
        this.show(items);
      } else {
        this.hide();
      }
    }, 250);
  }

  /** サジェストをサーバーから取得 */
  private async fetchSuggestions(query: string, postalCode: string): Promise<string[]> {
    const url = `${this.endpoint}?name=${encodeURIComponent(query)}&postal_code=${encodeURIComponent(postalCode)}`;
    try {
      const res = await fetch(url);
      if (!res.ok) return [];
      const json = (await res.json()) as { names?: string[] };
      return Array.isArray(json.names) ? json.names : [];
    } catch {
      return [];
    }
  }

  /** サジェストを描画して表示 */
  private show(items: string[]): void {
    this.box.innerHTML = items.map(name => `<div class="suggestion-item">${name}</div>`).join('');
    this.box.hidden = false;
  }

  /** サジェストを非表示 */
  private hide(): void {
    this.box.hidden = true;
    this.box.innerHTML = '';
  }

  /** クリックイベントで入力欄にセット */
  private onClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    if (target.classList.contains('suggestion-item')) {
      this.apartmentNameInput.value = target.textContent || '';
      this.hide();
    }
  }
}
